import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { Observable, map, of } from 'rxjs';
import { environment } from '../environments/environment';
import { AuthToken } from '../models/auth-token';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private _httpClient: HttpClient = inject(HttpClient);
  _authToken: AuthToken = {access_token: '', token_type: ''};

  getAuthToken(): Observable<AuthToken> {
    const credentials = btoa(environment.DEP_CREDENTIALS);
    const headers: HttpHeaders = new HttpHeaders().append('Authorization',`Basic ${credentials}`);
    const httpOptions = { headers: headers }

    let isTokenExpired = false;

    if (this._authToken.access_token !== '') {
      const decodedToken = jwtDecode(this._authToken.access_token);
      const expirationTime = decodedToken.exp;
      const currentTime = Math.floor(Date.now() / 1000);
      isTokenExpired = expirationTime === undefined ? false : expirationTime < currentTime;
    }

    if (this._authToken.access_token === '' || isTokenExpired){
      return this._httpClient.post<AuthToken>(environment.DEP_TOKEN_URL, '', httpOptions).pipe(map(resp => {
        this._authToken = { access_token: resp.access_token || 'no token found', token_type: resp.token_type || 'Bearer' };
        return resp as AuthToken;
      }));
    }
    return of(this._authToken);
  }
}
